import styled from 'styled-components'

interface IContainerProps {
  color: string
  hasCloseButton: boolean
}

export const Container = styled.li<IContainerProps>`
  position: relative;
  width: fit-content;
  padding: ${props => (props.hasCloseButton ? `0 3px 0 13px` : `0 13px`)};

  background: ${props => props.color};
  border-radius: 14px;
  text-decoration: none;

  display: flex;
  gap: 3px;
  align-items: center;
  justify-content: center;
`

export const Text = styled.span`
  color: ${({ theme }) => theme.zds.colors.neutral1000};
  font-size: 14px;
  line-height: 28px;
  font-weight: 400;
  font-family: Inter;

  pointer-events: none;
`

export const Button = styled.button`
  position: relative;
  width: 22px;
  height: 22px;

  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  svg {
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  &:focus-visible {
    border: 1px solid ${({ theme }) => theme.zds.colors.neutral1000};
    background: rgba(0, 0, 0, 0.2);
  }

  &:active {
    background: rgba(0, 0, 0, 0.3);
  }
`
